import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'strInsert',
  standalone: false
})
export class StringInsertPipe implements PipeTransform {
  transform(value: string, every: number, symbol: string): string {
    const regex = new RegExp(`.{1,${every}}`, 'g');;
    return value.trim().match(regex).join(symbol);
  }
}
